import { GET_POSITION } from '@/api/master-data/position/position';

const state = {
    positions: [],
    loading: false
};

const mutations = {
    setPositions: (state, payload) => {
        state.positions = payload;
    },
    setLoading: (state, payload) => {
        state.loading = payload;
    }
};

const actions = {
    getPositions: async ({ commit }, params) => {
        commit('setLoading', true);
        try {
            const resp = await GET_POSITION(params);
            if (resp.data.httpCode === 200) {
                commit('setPositions', resp.data.data); 
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit('setPositions', []);
            }
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },
};

const getters = {
    getPositions: (state) => state.positions,
    getLoading: (state) => state.loading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};